import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { MobileLayout } from './components/layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import {
  HomePage,
  LoginPage,
  RegisterPage,
  ForgotPasswordPage,
  MarketplacePage,
  ContractsPage,
  ContractDetailPage,
  ProviderPage,
  ProfilePage,
  NotificationsPage,
} from './pages';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          
          {/* Protected routes with mobile layout */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <MobileLayout>
                  <HomePage />
                </MobileLayout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/marketplace"
            element={
              <ProtectedRoute>
                <MobileLayout>
                  <MarketplacePage />
                </MobileLayout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/contracts"
            element={
              <ProtectedRoute>
                <MobileLayout>
                  <ContractsPage />
                </MobileLayout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/contracts/:id"
            element={
              <ProtectedRoute>
                <MobileLayout>
                  <ContractDetailPage />
                </MobileLayout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/provider"
            element={
              <ProtectedRoute>
                <MobileLayout>
                  <ProviderPage />
                </MobileLayout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <MobileLayout>
                  <ProfilePage />
                </MobileLayout>
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/notifications"
            element={
              <ProtectedRoute>
                <MobileLayout>
                  <NotificationsPage />
                </MobileLayout>
              </ProtectedRoute>
            }
          />
          
          {/* Catch all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
